import React from 'react';
import axios from 'axios';
import { API_ENDPOINTS } from '../config/api';
import { formatUSPhoneInput, toE164US } from '../utils/phone';
import './ContactModal.css';

const ContactModal = ({ isOpen, onClose }) => {
  const [formData, setFormData] = React.useState({
    fullName: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  const [status, setStatus] = React.useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: name === 'phone' ? formatUSPhoneInput(value) : value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');

    try {
      await axios.post(API_ENDPOINTS.contact, {
        name: formData.fullName,
        email: formData.email,
        phone: formData.phone ? toE164US(formData.phone) : formData.phone,
        subject: formData.subject,
        message: formData.message
      }, {
        headers: { 'Content-Type': 'application/json' }
      });

      setStatus('success');
      setFormData({ fullName: '', email: '', phone: '', subject: '', message: '' });

      setTimeout(() => {
        onClose();
        setStatus('');
      }, 3000);
    } catch (error) {
      setStatus('error');
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>×</button>

        <div className="modal-header">
          <h2>Get in Touch</h2>
          <p>We'd love to hear from you. Send us a message!</p>
          <p className="contact-email">
            <a href="mailto:support@rialty.ai">support@rialty.ai</a>
          </p>
        </div>

        <form onSubmit={handleSubmit} className="contact-form">
          <div className="form-group">
            <label htmlFor="fullName">Full Name *</label>
            <input
              type="text"
              id="fullName"
              name="fullName"
              value={formData.fullName}
              onChange={handleChange}
              required
              placeholder="Enter your full name"
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">Email *</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder="Enter your email"
            />
          </div>

          <div className="form-group">
            <label htmlFor="phone">Phone</label>
            <input
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              placeholder="Enter your phone number"
            />
          </div>

          <div className="form-group">
            <label htmlFor="subject">Subject *</label>
            <input
              type="text"
              id="subject"
              name="subject"
              value={formData.subject}
              onChange={handleChange}
              required
              placeholder="Enter subject"
            />
          </div>

          <div className="form-group">
            <label htmlFor="message">Message *</label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
              rows="5"
              placeholder="Enter your message"
            />
          </div>

          <div className="form-actions">
            <button
              type="submit"
              className="submit-btn"
              disabled={status === 'sending'}
            >
              {status === 'sending' ? 'Sending...' : 'Send Message'}
            </button>

            <button
              type="button"
              className="close-btn"
              onClick={onClose}
            >
              Close
            </button>
          </div>

          {status === 'success' && (
            <div className="status-message success">
              Thank you for reaching out! Your message has been sent successfully. We'll get back to you shortly.
            </div>
          )}

          {status === 'error' && (
            <div className="status-message error">
              Failed to send message. Please try again or email us directly at support@rialty.ai.
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default ContactModal;
